<script>
import ConfirmationModal from '@/components/general/ConfirmationModal'
export default {
  components: { ConfirmationModal },
  name: 'CompanyInviteCard',
  props: {
    headIcon: {
      type: String
    },
    headTitle: {
      type: String
    },
    inviteId: {
      type: String
    },
    disableButtons: {
      type: Boolean
    },
    limitDate: {
      type: Object
    },
    company: {
      type: Object
    },
    interviewDate: {
      type: Object
    },
    confirmationModalTitle: {
      type: String
    },
    confirmationModalDescription: {
      type: String
    }
  },
  data () {
    return {
      showConfirmationModal: false,
      disableConfirmationModalButtons: false
    }
  },
  methods: {
    confirmMeeting (responseMeeting) {
      if (responseMeeting !== 'decline') {
        this.$emit('acceptInvite')
        this.$store.dispatch('attemptAcceptCompanyInvite', this.inviteId).then(() => {
          this.$store.dispatch('attemptSetHasSearchedWorkspaces', false)
          this.$store.dispatch('attemptSetHasBeenSynchronized', false)
          window.location.href = `${this.baseUrl}/c/${this.company.subdomain}/tos?path=/c/${this.company.subdomain}&subdomain=${this.company.subdomain}&help=1`
        })
      } else {
        this.disableConfirmationModalButtons = true
        this.$store.dispatch('attemptDeclineCompanyInvite', this.inviteId).then(() => {
          this.$emit('refreshInvites')
        })
      }
    },
    confirmReject () {
      this.confirmMeeting('decline')
    }
  }
}
</script>
<template>
  <v-card class="company-invite-card--container">
    <div class="company-invite--head">
      <div class="company-invite--title-wrapper">
        <v-icon :color="getPrimaryColor">{{ headIcon }}</v-icon>
        <h3>{{ headTitle }}</h3>
      </div>
    </div>
    <div class="company-invite--info">
      <div class="company-invite--company">
        <v-avatar size="22">
          <v-img :src="company.logo" height="22" width="22"></v-img>
        </v-avatar>
        <p>{{ company.name }}</p>
      </div>
      <div class="company-invite--date">
        <div class="company-invite--date-day">
          <v-icon :color="getPrimaryColor">mdi-calendar-blank</v-icon>
          <p>{{ $t('company.invite.label:valid.until') }}: <span>{{ limitDate.day }}</span></p>
        </div>
      </div>
    </div>
    <div class="company-invite--actions">
      <template >
        <p>{{ $t('global:join') }}</p>
        <div class="company-invite--buttons">
          <v-btn :disabled="disableButtons" class="bold transform-unset mr-2 reject-company-btn" :color="getPrimaryColor" outlined @click="showConfirmationModal = true">{{ $t('global:reject') }}</v-btn>
          <v-btn :disabled="disableButtons" class="bold transform-unset" @click="confirmMeeting('confirm')" :color="getPrimaryColor" :dark="!disableButtons"><v-icon class="mr-2" size="14" color="#fff" >mdi-check</v-icon>{{ $t('global:accept') }}</v-btn>
        </div>
      </template>
    </div>
    <confirmation-modal
      :show="showConfirmationModal && !!confirmationModalTitle && !!confirmationModalDescription"
      :title="confirmationModalTitle"
      :description="confirmationModalDescription"
      :confirmText="$t('global:reject')"
      :btnConfirmText="false"
      :disableCancelBtn="disableConfirmationModalButtons"
      :disableConfirmBtn="disableConfirmationModalButtons"
      @confirm="confirmReject()"
      :cancelText="$t('global:cancel')"
      @cancel="showConfirmationModal = false"
    />
  </v-card>
</template>
<style lang="scss">
.company-invite-card--container {
  display: inline-block;
  width: 296px;
  height: 280px;
  max-width: 100%;
  margin: 12px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  .company-invite--head {
    background: #FAFAFA;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    .company-invite--title-wrapper {
      display: flex;
      align-items: center;
      .v-icon {
        margin-right: 8px;
      }
      h3 {
        font-family: $lato;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #454545;
      }
    }
  }
  .company-invite--info {
    padding: 16px;
    background: #FFFFFF;
    .company-invite--company {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .v-avatar {
        margin-right: 8px;
        border-radius: 100px;
      }
      p {
        font-family: 'Lato';
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #000000;
        margin-bottom: 0;
      }
    }
    .company-invite--date {
      padding: 8px;
      background: #FAFAFA;
      border: 1px solid rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      > div {
        display: flex;
        align-items: center;
        &:nth-child(1) {
          margin-bottom: 8px;
        }
        .v-icon {
          margin-right: 4px;
        }
        p {
          font-family: 'Lato';
          font-style: normal;
          font-size: 14px;
          line-height: 17px;
          color: #7E7D77;
          margin-bottom: 0;
          span {
            color: #000000;
            font-weight: bold;
          }
        }
      }
    }
  }
  .company-invite--actions {
    padding: 12px 20px;
    background: #FAFAFA;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    p {
      margin-bottom: 8px;
      font-family: 'Lato';
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      color: #454545;
    }
    .company-invite--buttons {
      display: flex;
      justify-content: space-between;
      .v-btn {
        flex-basis: calc(50% - 8px);
      }
    }
    .reject-company-btn {
      background: #FFF;
    }
    .join-company-btn {
      width: 100%;
    }
  }
}
</style>
